import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Dra. María Ferreyra',
    role: '',
    text: 'Tenía un reclamo bancario complicado y los modelos me permitieron resolverlo rápidamente.',
    rating: 5
  }, {
    name: 'Dr. Juan Pérez',
    role: '',
    text: 'El material me permitió comenzar a trabajar casos de consumo con mucha más seguridad.',
    rating: 5
  }, {
    name: 'Dra. Laura González',
    role: '',
    text: 'La inversión se recupera con el primer caso.',
    rating: 5
  }];
  return <section className="py-20 bg-legal-800" data-id="element-241">
      <div className="container mx-auto px-4" data-id="element-242">
        <div className="text-center mb-16" data-id="element-243">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-244">
            Lo que dicen nuestros clientes
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-245">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-900 p-8 rounded-xl border border-legal-700 relative" data-id="element-246">
              <div className="flex gap-1 mb-6" data-id="element-247">
                {[...Array(test.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-248" />)}
              </div>
              <p className="text-slate-300 mb-8 italic leading-relaxed" data-id="element-249">
                "{test.text}"
              </p>
              <div data-id="element-250">
                <p className="text-white font-bold" data-id="element-251">{test.name}</p>
                <p className="text-gold-500 text-sm" data-id="element-252">{test.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};